// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../assets/stylesheets/variables.scss\"","midnightColor":"#201C1C","spinnerIcon":"TemplateCategory_spinnerIcon__3W2Z0"};